import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=5a0665a7&scoped=true"
import script from "./AddStaff.vue?vue&type=script&lang=js"
export * from "./AddStaff.vue?vue&type=script&lang=js"
import style0 from "./AddStaff.vue?vue&type=style&index=0&id=5a0665a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0665a7",
  null
  
)

export default component.exports